export const PAYPAL_APPROVAL_LINK = "PAYPAL_APPROVAL_LINK";

export default (state = null, action) => {
    switch (action.type) {
        case PAYPAL_APPROVAL_LINK:
            return action.payload;
        default:
            return state;
    }
}
